import { Filter } from '@anytag/shared-molecules';
import { Template } from './Template';
import { useAnalyticsTrendingYoutubePostsFilter } from './hooks';

export const AnalyticsTrendingYoutubePostsFilter = () => {
  const { filter, setFilterForm } = useAnalyticsTrendingYoutubePostsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template />
    </Filter.Provider>
  );
};

export { useAnalyticsTrendingYoutubePostsFilter };
export * from './schemaTypes';
